export default "__VITE_ASSET__bf4c8518__"